__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "Creative-Workspace-frontend-HOST";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@module-federation/utilities", "3.1.32", () => (__webpack_require__.e(636).then(() => (() => (__webpack_require__(6636))))));
			register("@react-oauth/google", "0.12.1", () => (__webpack_require__.e(306).then(() => (() => (__webpack_require__(2306))))));
			register("@ricky0123/vad-react", "0.0.28", () => (__webpack_require__.e(506).then(() => (() => (__webpack_require__(2506))))));
			register("axios", "1.8.4", () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))));
			register("clsx", "2.1.1", () => (__webpack_require__.e(164).then(() => (() => (__webpack_require__(4164))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(1396))))));
			register("graphql-ws", "5.16.0", () => (__webpack_require__.e(930).then(() => (() => (__webpack_require__(3930))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(8987))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))));
			register("lucide-react", "0.474.0", () => (__webpack_require__.e(92).then(() => (() => (__webpack_require__(5092))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-frame-component", "5.2.7", () => (__webpack_require__.e(522).then(() => (() => (__webpack_require__(6522))))));
			register("react-hook-form", "7.53.2", () => (__webpack_require__.e(785).then(() => (() => (__webpack_require__(9785))))));
			register("react-lottie-player", "2.1.0", () => (__webpack_require__.e(200).then(() => (() => (__webpack_require__(3200))))));
			register("react-markdown", "9.0.1", () => (Promise.all([__webpack_require__.e(429), __webpack_require__.e(104), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(6104))))));
			register("react-resizable-panels", "2.1.7", () => (__webpack_require__.e(27).then(() => (() => (__webpack_require__(9027))))));
			register("react-router-dom", "7.1.1", () => (__webpack_require__.e(142).then(() => (() => (__webpack_require__(3142))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("reactflow", "11.11.4", () => (() => (__webpack_require__(1048))), 1);
			register("rehype-raw", "7.0.0", () => (Promise.all([__webpack_require__.e(429), __webpack_require__.e(867)]).then(() => (() => (__webpack_require__(1867))))));
			register("rehype-sanitize", "6.0.0", () => (__webpack_require__.e(617).then(() => (() => (__webpack_require__(3617))))));
			register("tailwind-merge", "2.5.5", () => (__webpack_require__.e(856).then(() => (() => (__webpack_require__(856))))));
			register("utf8", "3.0.0", () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(31))))));
			register("uuid", "11.0.3", () => (__webpack_require__.e(221).then(() => (() => (__webpack_require__(3221))))));
			register("wavesurfer.js", "7.8.9", () => (__webpack_require__.e(949).then(() => (() => (__webpack_require__(9949))))));
			register("zustand", "5.0.2", () => (__webpack_require__.e(618).then(() => (() => (__webpack_require__(5618))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};